module.exports = __webpack_public_path__ + "img/Dantam Hair 55.cdb5c001.jpg";